import React from "react";
import { Component, Fragment } from "react";

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	Dropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	ButtonDropdown,
	Tooltip
} from 'reactstrap';

import { Line, Bar } from 'react-chartjs-2';
import Chart from 'react-c3-component';
import 'c3/c3.css';
import Moment from 'moment';
import {
	appendProductFilter,
	beginDashboardRequest,
	finishDashboardRequest,
	markDashboardRequestSucceeded,
	getDashboardRefreshWait,
	getStoredProductType,
	ignoreDashboardRequestError,
	isDashboardRequestCurrent,
	scheduleDashboardRetry,
	stopDashboardPolling
} from '../product-filter';
import DashboardCardLoader from '../dashboard-card-loader';
var moment = require('moment-timezone');


let lineOptions = {
	elements: { point: { radius: 2 } },
	maintainAspectRatio: false,
	tooltips: {
		titleFontSize: 16,
		bodyFontSize: 14
	},
	layout: {
			padding: {
				right: 6
			}
	},
	plugins: {
		datalabels: {
			display: false,
		}
	},
	scales: {
		xAxes: [{
			gridLines: {
				display: false,
				drawBorder: false,
			},
			ticks: {
				display: false
			}
		}],
		yAxes: [{
			gridLines: {
				display: false,
				drawBorder: false,
			},
			ticks: {
				display: false
			}
		}]
	},
	legend: {
		display: false,
		labels: {
			fontColor: 'rgb(255, 99, 132)'
		}
	}
};

//Line chart
let lineData2 = {
	labels: [1, 2, 3, 4, 5, 6, 7, 8],
	datasets: [{
		label: 'Outcome',
		borderWidth: 2,
		backgroundColor: 'rgba(79,195,247,.1)',
		borderColor: 'rgb(79,195,247)',
		pointBorderColor: 'rgb(79,195,247)',
		pointBackgroundColor: 'rgb(79,195,247)',
		data: [0, 8, 11, 22, 8, 10, 5, 21]
	}]
};

class LaserUsage extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);
    this.state = {
			totalUsage: '',
			usage: [],
			chartData: {},
			noDevices: false,
			noDataForDevices: false,
			currentDataSetting: 0,
			startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD'),
			endDate: Moment().format('YYYY-MM-DD'),
			currentDate: Moment().format('YYYY-MM-DD'),
			isOpen: false,
			currentItem: "Global",
			tooltipOpen: false,
			deviceList: JSON.parse(localStorage.getItem('deviceList')),
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			marketType: localStorage.getItem('marketType') ? JSON.parse(localStorage.getItem('marketType')) : 0,
			productType: getStoredProductType(),
			isLoading: false
	  };

		this.toggleDropDown = this.toggleDropDown.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.toggleTooltip = this.toggleTooltip.bind(this);

  }

	async componentDidMount() {

		//console.log("currentUser Laser usage: "+ this.state.currentUser);
		document.body.addEventListener('set-market-type', this.handleMarketTypeChange.bind(this));
		document.body.addEventListener('set-product-type', this.handleProductTypeChange.bind(this));

		if (this.state.currentUser) {
			if (this.state.currentUser.payload["custom:role"] && this.state.currentUser.payload["custom:role"]>0) {
				this.selectDropDownItem(1, "By Week");
				//this.getData();
			} else {
				this.scheduleDataRefresh();
			}
		} else {
			this.scheduleDataRefresh();
		}

		if (this.props.config) {
			this.selectDropDownItem(0, 'Global')
		}
	}

	scheduleDataRefresh(delay, showLoader = true) {
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (showLoader) {
			this.setState({ isLoading: true, totalUsage: "" });
		}
		this.dashboardRefreshTimeout = setTimeout(()=>{ this.getData({ showLoader }); }, delay || getDashboardRefreshWait('laserUsage'));
	}

	hasChartData() {
		return this.state.chartData && this.state.chartData.datasets && this.state.chartData.datasets.length > 0;
	}

	getUsageDate(row) {
		return row.date || row.Date || row.CreationDate || row.creationDate || row.creationdate;
	}

	getUsageSeconds(row) {
		const seconds = row.dailyusageseconds || row.dailyUsageSeconds || row.DailyUsageSeconds || row.totalseconds || row.totalSeconds || row.TotalSeconds || row.seconds || row.Seconds;
		const parsedSeconds = parseFloat(seconds);
		return Number.isFinite(parsedSeconds) ? parsedSeconds : 0;
	}

	buildChartData(results) {
		const rows = (results || []).filter(row => this.getUsageDate(row));

		return {
			labels: rows.map(row => Moment(this.getUsageDate(row)).format('MMM Do YYYY')),
			datasets: [{
				label: 'Total Minutes',
				borderWidth: 2,
				backgroundColor: 'rgba(79,195,247,.1)',
				borderColor: 'rgb(79,195,247)',
				pointBorderColor: 'rgb(79,195,247)',
				pointBackgroundColor: 'rgb(79,195,247)',
				data: rows.map(row => parseFloat(this.getUsageSeconds(row) / 60).toFixed(2))
			}]
		};
	}

	componentWillUnmount() {
		//console.log("Laser-Usage componentWillUnmount");
		clearInterval(this.intervalID);
		clearTimeout(this.dashboardRefreshTimeout);
		clearTimeout(this.dashboardRetryTimeout);
		this.dashboardRetryScheduled = false;
		stopDashboardPolling(this);
		if (this.dashboardAbortController) {
			this.dashboardAbortController.abort();
		}
		document.body.removeEventListener('set-market-type', this.handleMarketTypeChange.bind(this));
		document.body.removeEventListener('set-product-type', this.handleProductTypeChange.bind(this));
	}

	handleMarketTypeChange(event) {
		console.log("Laser Usage Market has changed to: ", event.detail);
    // your business logic here .. this.setState({...});
		this.setState({ marketType: event.detail.id });
		this.scheduleDataRefresh();
  }

	handleProductTypeChange(event) {
		console.log("Laser Usage Product has changed to: ", event.detail);
		this.setState({ productType: event.detail.id });
		this.scheduleDataRefresh();
  }

	toggleTooltip() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

	toggleDropDown() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

	handleChange(event) {
		if (event.target.getAttribute('name') == 'startDate') {
			this.setState({startDate: event.target.value});
			this.setState({
	      currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		} else if (event.target.getAttribute('name') == 'endDate') {
			//console.log('this.state.code: ' + event.target.value);
			this.setState({endDate: event.target.value});
			this.setState({
				currentItem: "Custom Range",
				currentDataSetting: 3
	    });
		}

		this.scheduleDataRefresh();
  }

	handleSubmit(event) {

		this.getData({ showLoader: true });
  }

	selectDropDownItem(id, title) {

    this.setState({
      currentItem: title,
			currentDataSetting: id
    });

		if (id==1) {
			this.setState({ startDate: Moment().subtract(1, 'week').format('YYYY-MM-DD') });
		} else if (id==2) {
			this.setState({ startDate: Moment().subtract(1, 'month').format('YYYY-MM-DD') });
		} else if (id==3) {
			this.setState({ startDate: Moment().format('YYYY-MM-DD') });
		}

		this.setState({ endDate: Moment().format('YYYY-MM-DD') });
		//this.getData();
		this.scheduleDataRefresh();
  }

	stepBack () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).subtract(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).subtract(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}
		this.scheduleDataRefresh();
	}

	stepForward () {
		if (this.state.currentDataSetting==1) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'week').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'week').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		} else if (this.state.currentDataSetting==2) {
			let revisedStartDate = Moment(this.state.startDate).add(1, 'month').format('YYYY-MM-DD');
			let revisedEndDate = Moment(this.state.endDate).add(1, 'month').format('YYYY-MM-DD');
			console.log("Revised Start Date: " + JSON.stringify(revisedStartDate));
			console.log("Revised End Date: " + JSON.stringify(revisedEndDate));
			this.setState({ startDate: revisedStartDate });
			this.setState({ endDate: revisedEndDate });
		}
		this.scheduleDataRefresh();
	}

	getData = async (options = {}) => {
		const request = beginDashboardRequest(this, options.showLoader === true);
		const signal = request.controller.signal;

		if (options.showLoader === true) {
			this.setState({ totalUsage: "" });
		}

		var timezone = Moment.tz.guess();

		var productType = this.props.productID ? this.props.productID : this.state.productType;

		if (this.state.currentDataSetting==0) {

			var url1 = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"global-laser-usage-total?MarketType="+this.state.marketType, productType);

			var token = "";

			if (this.state.currentUser) {
				token = this.state.currentUser.jwtToken;
			}

			if (this.props.authToken) {
				console.log("laser-usage this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {

				const response1 = await fetch(url1, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body1 = await response1.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("globallaserusagetotal body response: " + JSON.stringify(body1));

				if (body1.status == 'Success') {
					markDashboardRequestSucceeded(this, request.requestId);
					if (body1.results.length>0) {
						//let total = parseFloat(body1.results[0].totalseconds, 10)/60;

						var d = Number(body1.results[0].totalseconds);
						var h = Math.floor(d / 3600);
						var m = Math.floor(d % 3600 / 60);
						var s = Math.floor(d % 3600 % 60);

						var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
						var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
						var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " sec") : "";

						this.setState({ totalUsage: hDisplay + mDisplay + sDisplay });
						this.setState({
							noDataForDevices: false
						});
					} else {
						//this.setState({ chartData: {}, noDataForDevices: true });
						//this.setState({ totalUsage: "" });
						if (this.state.totalUsage) {
							this.setState({
								noDataForDevices: false
							});
						} else {
							this.setState({
								chartData: {},
								noDataForDevices: true,
								totalUsage: ""
							});
						}
					}
					this.forceUpdate();
				} else {
					//this.setState({ chartData: {}, noDataForDevices: true });
					//this.setState({ totalUsage: "" });
					if (this.state.totalUsage) {
						this.setState({
							noDataForDevices: false
						});
					} else {
						this.setState({
							chartData: {},
							noDataForDevices: true,
							totalUsage: ""
						});
					}
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData({ showLoader: true }))) {
					console.log(err);
				}
			}

			var url = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"global-laser-usage-by-day?MarketType="+this.state.marketType+"&Timezone="+timezone, productType);

			try {

				const response = await fetch(url, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("globallaserusagebyday body response: " + JSON.stringify(body));

				if (body.status == 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);
					if (body.results.length>0) {
						this.setState({ startDate: Moment(this.getUsageDate(body.results[0])).format('YYYY-MM-DD') });
						this.setState({ endDate: Moment(this.getUsageDate(body.results[body.results.length-1])).format('YYYY-MM-DD') });
						const chartData = this.buildChartData(body.results);

						this.setState({ usage: body.results, noDataForDevices: false });
						this.setState({ chartData });
					} else {
						//this.setState({ chartData: {}, noDataForDevices: true });
						//this.setState({ totalUsage: "" });
						if (this.state.totalUsage || this.hasChartData()) {
							this.setState({
								noDataForDevices: false
							});
						} else {
							this.setState({
								chartData: {},
								noDataForDevices: true,
								totalUsage: ""
							});
						}
					}
					//this.forceUpdate();
				} else {
					//this.setState({ chartData: {}, noDataForDevices: true });
					//this.setState({ totalUsage: "" });
					if (this.state.totalUsage || this.hasChartData()) {
						this.setState({
							noDataForDevices: false
						});
					} else {
						this.setState({
							chartData: {},
							noDataForDevices: true,
							totalUsage: ""
						});
					}
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData({ showLoader: true }))) {
					console.log(err);
				}
			}

		} else {

			var url1 = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"global-laser-usage-total-date-range?MarketType="+this.state.marketType+"&StartDate="+this.state.startDate+"&EndDate="+this.state.endDate+"&Timezone="+timezone, productType);

			var token = "";

			if (this.state.currentUser) {
				token = this.state.currentUser.jwtToken;
			}

			if (this.props.authToken) {
				console.log("LaserUsage this.props.authToken: " + this.props.authToken);
				token = this.props.authToken;
			}

			try {

				const response1 = await fetch(url1, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body1 = await response1.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("globallaserusagetotal body response: " + JSON.stringify(body1));

				if (body1.status == 'Success') {
					markDashboardRequestSucceeded(this, request.requestId);
					if (body1.results.length>0) {
						//let total = parseFloat(body1.results[0].totalseconds, 10)/60;

						var d = Number(body1.results[0].totalseconds);
						var h = Math.floor(d / 3600);
						var m = Math.floor(d % 3600 / 60);
						var s = Math.floor(d % 3600 % 60);

						var hDisplay = h > 0 ? h + (h == 1 ? " hr, " : " hrs, ") : "";
						var mDisplay = m > 0 ? m + (m == 1 ? " min, " : " mins, ") : "";
						var sDisplay = s > 0 ? s + (s == 1 ? " sec" : " sec") : "";

						this.setState({ totalUsage: hDisplay + mDisplay + sDisplay });
					} else {
						this.setState({ chartData: {}, noDataForDevices: true });
						this.setState({ totalUsage: "" });
					}
					this.forceUpdate();
				} else {
					this.setState({ chartData: {}, noDataForDevices: true });
					this.setState({ totalUsage: "" });
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData({ showLoader: true }))) {
					console.log(err);
				}
			}

			var url = appendProductFilter("https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"global-laser-usage-by-day-date-range?MarketType="+this.state.marketType+"&StartDate="+this.state.startDate+"&EndDate="+this.state.endDate+"&Timezone="+timezone, productType);

			try {

				const response = await fetch(url, {
					method: 'GET',
					signal,
					headers: {
						Authorization: token
					},
				});

				const body = await response.json();
				if (!isDashboardRequestCurrent(this, request.requestId)) {
					return;
				}
				console.log("globallaserusagebyday body response: " + JSON.stringify(body));

				if (body.status == 'Success') {
				markDashboardRequestSucceeded(this, request.requestId);
					if (body.results.length>0) {
						const chartData = this.buildChartData(body.results);

						this.setState({ usage: body.results, noDataForDevices: false });
						this.setState({ chartData });
					} else {
						if (this.state.totalUsage || this.hasChartData()) {
							this.setState({ noDataForDevices: false });
						} else {
							this.setState({ chartData: {}, noDataForDevices: true });
							this.setState({ totalUsage: "" });
						}
					}
					//this.forceUpdate();
				} else {
					if (this.state.totalUsage || this.hasChartData()) {
						this.setState({ noDataForDevices: false });
					} else {
						this.setState({ chartData: {}, noDataForDevices: true });
						this.setState({ totalUsage: "" });
					}
				}

			}
			catch (err) {
				if (!scheduleDashboardRetry(this, request.requestId, err, () => this.getData({ showLoader: true }))) {
					console.log(err);
				}
			}

		}

		finishDashboardRequest(this, request.requestId, () => this.getData({ showLoader: false }));
	}

	render() {
		return (
      <Card className="card-hover">
				<CardBody style={{ minHeight: 270, position: 'relative' }}>
					<Row>
						<Col xs="6" md="6" lg="6" className="text-left">
							<CardTitle>Life Time Laser Usage
							<i style={{color: '#ffffff'}} className="mdi mdi-information-outline ml-1" id="LaserUsageTooltip"/>
							<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="LaserUsageTooltip" toggle={this.toggleTooltip}>
								Displays total laser usage time by desired time period. This is how long the laser has been fired in both manual and preset modes.
							</Tooltip>
							</CardTitle>
						</Col>
						<Col xs="6" md="6" lg="6" className="text-right">
							<ButtonDropdown isOpen={this.state.isOpen} toggle={this.toggleDropDown}>
								<DropdownToggle color="dark" caret>
									{this.state.currentItem}
								</DropdownToggle>
								<DropdownMenu right>

									<DropdownItem onClick={() => this.selectDropDownItem(0, 'Global')}>Global</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(1, 'By Week')}>By Week</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(2, 'By Month')}>By Month</DropdownItem>
									<DropdownItem onClick={() => this.selectDropDownItem(3, 'Custom Range')}>Custom Range</DropdownItem>
								</DropdownMenu>
							</ButtonDropdown>
						</Col>
					</Row>
					{this.state.noDevices ? (
						<div className="mt-5 text-center">
							<h5>User has no devices</h5>
						</div>
					) : (
						<Fragment>
						{this.state.currentDataSetting == 0 || this.state.currentDataSetting == 3 ? (
							<Fragment>
							<div style={{ position: 'absolute', left: 58, right: 58, top: 78 }}>
								<div className="chart-wrapper" style={{ width: '100%', margin: '0 auto', height: 92 }}>
									{this.state.isLoading ? (
										<DashboardCardLoader />
									) : this.state.noDataForDevices ? (
										<div className="text-center pt-3" style={{ width: '80%', margin: '0 auto', height: '100%' }}>
											<h5>No data for user's devices</h5>
										</div>
									) : (
										<Line data={this.state.chartData} options={lineOptions} />
									)}
								</div>
							</div>
							<div className="text-center" style={{ position: 'absolute', left: 58, right: 58, bottom: this.state.currentDataSetting != 0 ? 60 : 24 }}>
								{!this.state.noDataForDevices &&
									<span style={{color:'#33d1bf'}}>{this.state.totalUsage}</span>
								}
							</div>
							{this.state.currentDataSetting != 0 &&
								<Fragment>
								<Row style={{ position: 'absolute', left: 20, right: 20, bottom: 24 }}>
									<Col lg="12" xl="6" className="text-right">
										<div className="float-left" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
										</div>
									</Col>
									<Col lg="12" xl="6" className="">
										<div className="float-left text-right" style={{ minWidth: '10%' }}>
											<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
										</div>
										<div className="float-left ml-1" style={{ minWidth: '75%' }}>
											<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
										</div>
										{
											// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
											// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Vitals" disabled={this.state.currentDataSetting != 3}>
											// 	GO
											// </Button>
											// </div>
										}

									</Col>
								</Row>
								</Fragment>
							}
							</Fragment>
						) : (
							<Fragment>
							<Row className="align-items-center" style={{ position: 'absolute', left: 20, right: 20, top: 82 }}>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" onClick={() => this.stepBack()} title="Vitals">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-left mdi-24px"/>
									</Button>
								</div>
								<div style={{ width: '80%', margin: '0 auto', height: '100%' }}>
									<div style={{ margin: '0 auto' }}>
										<div className="chart-wrapper" style={{ width: '100%', margin: '0 auto', height: 92 }}>
											{this.state.isLoading ? (
												<DashboardCardLoader />
											) : this.state.noDataForDevices ? (
												<div className="text-center pt-3" style={{ width: '80%', margin: '0 auto', height: '100%' }}>
													<h5>No data for user's devices</h5>
												</div>
											) : (
												<Line data={this.state.chartData} options={lineOptions} />
											)}
										</div>
									</div>
								</div>
								<div style={{ width: '10%', margin: '0 auto', height: '100%' }}>
									<Button size="sm" color="link" disabled={this.state.currentDate==this.state.endDate} onClick={() => this.stepForward()} title="Vitals">
										<i style={{color: '#b3b5bb'}} className="mdi mdi-arrow-right mdi-24px"/>
									</Button>
								</div>
							</Row>
							<div className="text-center" style={{ position: 'absolute', left: 58, right: 58, bottom: 60 }}>
								{!this.state.noDataForDevices &&
									<span style={{color:'#33d1bf'}}>{this.state.totalUsage}</span>
								}
							</div>
							<Row style={{ position: 'absolute', left: 20, right: 20, bottom: 24 }}>
								<Col lg="12" xl="6" className="text-right">
									<div className="float-left" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>From:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='startDate' size='sm' type="date" value={this.state.startDate} onChange={this.handleChange} />
									</div>
								</Col>
								<Col lg="12" xl="6" className="">
									<div className="float-left text-right" style={{ minWidth: '10%' }}>
										<h6 style={{ lineHeight: '1.8', minWidth: '40px' }}>To:</h6>
									</div>
									<div className="float-left ml-1" style={{ minWidth: '75%' }}>
										<Input style={{ minWidth: '135px' }} name='endDate' size='sm' type="date" value={this.state.endDate} onChange={this.handleChange} />
									</div>
									{
										// <div className="float-left ml-1" style={{ minWidth: '16%' }}>
										// <Button size="sm" color="dark" onClick={() => this.handleSubmit()} title="Vitals">
										// 	GO
										// </Button>
										// </div>
									}
								</Col>
							</Row>
							</Fragment>
						)}
						</Fragment>
					)}
        </CardBody>
      </Card>
		);
	}
}

export default LaserUsage;
